import React from "react";
import { useTranslation } from "react-i18next";
import Button from "src/components/Button";
import Card from "src/components/Card";

const NoTasksCard = () => {
	const { t } = useTranslation("tasks", {
		keyPrefix: "empty-card",
	});

	const INSTRUCTIONS = [
		t("instructions.description"),
		t("instructions.budget"),
		t("instructions.location"),
		t("instructions.interview"),
		t("instructions.date"),
	];

	return (
		<Card>
			<div className="flex flex-col gap-4  max-w-md">
				<h2>{t("title")}</h2>
				<p className="">
					{t("description", {
						count: INSTRUCTIONS.length,
					})}
				</p>
				<ul className="pl-8">
					{INSTRUCTIONS.map((item, index) => (
						<li key={`instruction-${index}`} className="flex gap-2">
							<strong className="w-6">{index + 1}.</strong>
							{item}
						</li>
					))}
					<li className="flex gap-2 text-primary">
						<strong className="w-6">
							<i className="fas fa-check"></i>
						</strong>
						{t("instructions.finish")}
					</li>
				</ul>

				<div className="flex items-center gap-4">
					<Button to="/tasks/create">
						{t("cta")}
						<i className="fas fa-plus ml-2"></i>
					</Button>
				</div>
			</div>
		</Card>
	);
};

export default NoTasksCard;
